import { render, staticRenderFns } from "./CheckSimpleTotalsPanel.vue?vue&type=template&id=381d0d0a&"
import script from "./CheckSimpleTotalsPanel.vue?vue&type=script&lang=js&"
export * from "./CheckSimpleTotalsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports